import React, { Component, Fragment } from 'react';
import { Table, Segment, Header, Grid, Button, Popup } from 'semantic-ui-react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import ExternalStudentEditWrapper from '../ExternalStudentForms/ExternalStudentEditWrapper';
import { getProgramName } from '../ExternalStudentForms/ExternalStudentInputForm';

class ExternalStudentBasicInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            student: props.student,
            editingPersonalInformation: false,
            editingSendingInstitution: false,
            editingExchangeInformation: false,
            unlockLoading: false,
        };
        this.onCancel = this.onCancel.bind(this);
    }

    onCancel = () => {
        this.setState({
            editingPersonalInformation: false,
            editingSendingInstitution: false,
            editingExchangeInformation: false
        });
    };

    onEdit = (editedStudent) => {
        // console.log("Edited student:");
        // console.log(editedStudent);
        this.setState({
            student: editedStudent,
            editingPersonalInformation: false,
            editingSendingInstitution: false,
            editingExchangeInformation: false
        });
        this.props.onEdit(editedStudent);
    };

    render() {
        const {
            editingPersonalInformation,
            editingSendingInstitution,
            editingExchangeInformation,
            student,
        } = this.state;

        const { isMainOU } = this.props;

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isInternationalCooperationService = localStorageRole === 'Služba za međunarodnu saradnju';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';

        return (
            <Grid columns={2} stackable centered>
                <Grid.Row>
                    <Grid.Column>
                        {editingPersonalInformation
                            ?
                            <ExternalStudentEditWrapper
                                student={student}
                                personalInformation={true}
                                exchangeInformation={false}
                                sendingInstitution={false}
                                onCancel={this.onCancel}
                                onEdit={this.onEdit}
                            />
                            :
                            <Segment.Group>
                                <Segment>
                                    <Header as="h3">
                                        <Header.Content style={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}>
                                            <FormattedMessage id="externalStudent.personalData"/>
                                            {(isInternationalCooperationService || (isStudentService && isMainOU)) &&
                                                (<Popup
                                                    content={<FormattedMessage id="externalStudent.edit"/>}
                                                    position="top center"
                                                    trigger={<Button
                                                        icon="pencil"
                                                        circular
                                                        floated="right"
                                                        basic
                                                        color="green"
                                                        disabled={student.lockedAt || editingPersonalInformation || editingExchangeInformation || editingSendingInstitution}
                                                        size={'mini'}
                                                        onClick={() => {
                                                            this.setState({ editingPersonalInformation: true });
                                                        }}
                                                    />}/>)}
                                        </Header.Content>
                                    </Header>
                                </Segment>
                                <Segment>
                                    <Table basic="very" compact celled>
                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.fullName"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.firstName + ' ' + student.lastName}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.email"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.email}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.birthDate"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.dateOfBirth ? moment(student.dateOfBirth)
                                                    .format('D. M. YYYY.') : '-'}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.gender"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.gender && student.gender.name}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.birthCountry"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.birthCountry && student.birthCountry.name}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.birthPlaceName"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.birthPlaceName}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.citizenshipCountry"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.citizenshipCountry && student.citizenshipCountry.name}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.jmbg"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.jmbg}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.esi"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.europeanStudentIdentifier}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.englishLevelCompetence"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.englishLevelCompetence && `${student.englishLevelCompetence.abbreviation} - ${student.englishLevelCompetence.name}`}</Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                </Segment>
                            </Segment.Group>
                        }
                    </Grid.Column>
                    <Grid.Column>
                        {editingSendingInstitution ?
                            <ExternalStudentEditWrapper
                                student={student}
                                personalInformation={false}
                                exchangeInformation={false}
                                sendingInstitution={true}
                                onCancel={this.onCancel}
                                onEdit={this.onEdit}
                            /> :
                            <Segment.Group>
                                <Segment>
                                    <Header as="h3">
                                        <Header.Content style={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}>
                                            <FormattedMessage id="externalStudent.sendingInstitutionData"/>
                                            {(isInternationalCooperationService || (isStudentService && isMainOU)) &&
                                                (<Popup
                                                    content={<FormattedMessage id="externalStudent.edit"/>}
                                                    position="top center"
                                                    trigger={<Button
                                                        icon="pencil"
                                                        circular
                                                        floated="right"
                                                        basic
                                                        color="green"
                                                        disabled={student.lockedAt || editingPersonalInformation || editingExchangeInformation || editingSendingInstitution}
                                                        size={'mini'}
                                                        onClick={() => {
                                                            this.setState({ editingSendingInstitution: true });
                                                        }}
                                                    />}/>)}
                                        </Header.Content>
                                    </Header>
                                </Segment>
                                <Segment>
                                    <Table basic="very" compact centered relaxed celled>
                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.institutionName"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.sendingInstitutionName}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.institutionFaculty"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.sendingInstitutionFacultyName}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.institutionDepartment"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.sendingInstitutionDepartment}</Table.Cell>
                                            </Table.Row>
                                            {student.mobilityProgram && student.mobilityProgram.name === 'ERASMUS' &&
                                                <Table.Row>
                                                    <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                        <FormattedMessage id="externalStudent.institutionErasmusCode"/>
                                                    </Table.Cell>
                                                    <Table.Cell>{student.sendingInstitutionErasmusCode}</Table.Cell>
                                                </Table.Row>
                                            }
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.institutionCountry"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.sendingInstitutionCountry && student.sendingInstitutionCountry.name}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.institutionAddress"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.sendingInstitutionAddress}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.contactPersonFirstName"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.sendingContactPersonFirstName} {student.sendingContactPersonLastName}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.contactPersonEmail"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.sendingContactPersonEmail}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.contactPersonPhone"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.sendingContactPersonPhone}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.studyCycle"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.studyCycle && student.studyCycle.name}</Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                </Segment>
                            </Segment.Group>}
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column style={{ width: '100%' }}>
                        {editingExchangeInformation ? <ExternalStudentEditWrapper
                                student={student}
                                personalInformation={false}
                                exchangeInformation={true}
                                sendingInstitution={false}
                                onCancel={this.onCancel}
                                onEdit={this.onEdit}
                            /> :
                            <Segment.Group>
                                <Segment>
                                    <Header as="h3">
                                        <Header.Content style={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}>
                                            <FormattedMessage id="externalStudent.exchangeData"/>
                                            {(isInternationalCooperationService || (isStudentService && isMainOU)) &&
                                                (<Popup
                                                    content={<FormattedMessage id="externalStudent.edit"/>}
                                                    position="top center"
                                                    trigger={<Button
                                                        icon="pencil"
                                                        circular
                                                        floated="right"
                                                        basic
                                                        color="green"
                                                        disabled={student.lockedAt || editingPersonalInformation || editingExchangeInformation || editingSendingInstitution}
                                                        size={'mini'}
                                                        onClick={() => {
                                                            this.setState({ editingExchangeInformation: true });
                                                        }}
                                                    />}/>)}
                                        </Header.Content>
                                    </Header>
                                </Segment>
                                <Segment>
                                    <Table basic="very" compact celled>
                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.mobilityProgram"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.mobilityProgram && student.mobilityProgram.name}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.mobilityType"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.mobilityType && student.mobilityType.name}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.studyType"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.studyType && student.studyType.name}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.mobilityFormat"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.mobilityFormat && student.mobilityFormat.name}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.academicYear"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.academicYear && student.academicYear.name}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.programName"/>
                                                </Table.Cell>
                                                <Table.Cell>{getProgramName(student)}</Table.Cell>
                                            </Table.Row>
                                            {student.mobilityType && student.mobilityType._key === 'cycle' &&
                                                <Fragment>
                                                    <Table.Row>
                                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                            <FormattedMessage
                                                                id="externalStudent.externalStudentSemester"/>
                                                        </Table.Cell>
                                                        <Table.Cell>{student.semester && student.semester.name}</Table.Cell>
                                                    </Table.Row>
                                                </Fragment>}
                                            {student.mobilityType && student.mobilityType._key === 'non_cycle' &&
                                                <Table.Row>
                                                    <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                        <FormattedMessage id="externalStudent.nonCycleProgram"/>
                                                    </Table.Cell>
                                                    <Table.Cell>{student.nonCycleProgram ? student.nonCycleProgram.programName : '-'}</Table.Cell>
                                                </Table.Row>}
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.fieldOfEducation"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.fieldOfEducation && (student.fieldOfEducation.name + ' | ' + student.fieldOfEducation.code)}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.scholarshipAmount"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.scholarshipAmount != null ? student.scholarshipAmount : '-'}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.languages"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.languages && student.languages.length > 0 ? student.languages.map(l => l.name)
                                                    .join(', ') : '-'}</Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                </Segment>
                            </Segment.Group>}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

export default ExternalStudentBasicInformation;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentProfile/ExternalStudentBasicInformation.js